import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiDelete } from '@/lib/api';

export function useDeleteTrackedKeyword(projectId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => apiDelete(`/v1/tracked-keywords/${id}`),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['tracked-keywords', projectId] });
      void qc.invalidateQueries({ queryKey: ['rank-summary', projectId] });
    },
  });
}
